// extracted by mini-css-extract-plugin
module.exports = {"scroll":"vertical-scroll_scroll__1ZodD"};